import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'cc-channels-feature',
  templateUrl: './channels-feature.component.html',
  styleUrls: ['./channels-feature.component.scss']
})
export class ChannelsFeatureComponent implements OnInit {
  @Input() public title = '';
  @Input() public description = '';
  @Input() public imageUrl = '';

  constructor() {}

  ngOnInit() {}
}
